import React from 'react';
import Section from '../../shared/Section/Section';
import TargetAudienceCard from '../../shared/TargetAudienceCard/TargetAudienceCard';
import { Box } from '@mui/material';

export default function TargetAudience({ title, list, imgs }) {
  return (
    <Section title={title} theme="light" withoutBg>
      <Box sx={{ width: '100%', overflowX: 'auto' }}>
        <Box
          sx={{
            display: 'flex',
            gap: { xs: 1, md: 3 },
            overflowX: 'scroll',
            minWidth: 'min-content',
          }}
        >
          {list.map((card) => (
            <TargetAudienceCard
              key={card.title}
              card={card}
              image={imgs[`target/${card.image}`]}
            />
          ))}
        </Box>
      </Box>
    </Section>
  );
}
